import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import logo from '../../images/my_btn_mb_w.png';
import { useAppContext } from 'utils/store';
import * as fireonApi from "../../apis/FireOnApi";
import { apiWrapper } from 'apis/CommonApi';
import { API_HOST } from 'Constants';

//건물 상세 현황
export default function BuildingDetailStatusComponent(props) {
    const navigate = useNavigate();
    let { id } = useParams();
    const [isPreviewModalVisible, setPreviewModalVisible] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    const [floorPlanImageFiles, setFloorPlanImageFiles] = useState([]);
    const [boundaryPreviewImageFiles, setBoundaryPreviewImageFiles] = useState([]);
    const [photoImageFiles, setPhotoImageFiles] = useState([]);
    const [previewImageSrc, setPreviewImageSrc] = useState(null);

    useEffect(() => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getBuildingDetail(id);
            if (status === true) {
                setDataSource(data);

                //층별 평면도
                const newFloorPlanImageFiles = await Promise.all(data.floors.map(async (item) => {
                    if (item.floorPlanImage === null) {
                        return null;
                    } else {
                        //이미지 URL -> Blob 변환
                        try {
                            const imageSrc = API_HOST + item.floorPlanImage;
                            const response = await fetch(imageSrc);
                            if (!response.ok) {
                                throw new Error(`${response.status}`);
                            }

                            const blob = await response.blob();
                            const file = new File([blob], item.floorPlanImageFilename, { type: blob.type });
                            return {
                                floorPlanImageSrc: imageSrc,
                                floorPlanImageFile: file,
                            };
                        } catch (error) {
                            console.error("층별 평면도 이미지 URL을 Blob 객체로 변환 실패 : ", error)
                            return null;
                        }
                    }
                }));
                setFloorPlanImageFiles(newFloorPlanImageFiles);

                //경계구역 일람도
                const newBoundaryPreviewImageFiles = await Promise.all(data.floors.map(async (item) => {
                    if (item.boundaryPreviewImage === null) {
                        return null;
                    } else {
                        //이미지 URL -> Blob 변환
                        try {
                            const imageSrc = API_HOST + item.boundaryPreviewImage;
                            const response = await fetch(imageSrc);
                            if (!response.ok) {
                                throw new Error(`${response.status}`);
                            }

                            const blob = await response.blob();
                            const file = new File([blob], "", { type: blob.type });
                            return {
                                boundaryPreviewImageSrc: imageSrc,
                                boundaryPreviewImageFile: file,
                            };
                        } catch (error) {
                            console.error("경계구역일람도 이미지 URL을 Blob 객체로 변환 실패 : ", error)
                            return null;
                        }
                    }
                }));
                setBoundaryPreviewImageFiles(newBoundaryPreviewImageFiles);

                //건물 사진
                const newPhotoImageFiles = await Promise.all(data.photos.map(async (item) => {
                    if (item.photoImage === null) {
                        return null;
                    } else {
                        //이미지 URL -> Blob 변환
                        try {
                            const imageSrc = API_HOST + item.photoImage;
                            const response = await fetch(imageSrc);
                            if (!response.ok) {
                                throw new Error(`${response.status}`);
                            }

                            const blob = await response.blob();
                            const file = new File([blob], item.photoImageFilename, { type: blob.type });
                            return {
                                photoImageSrc: imageSrc,
                                photoImageFile: file,
                            };
                        } catch (error) {
                            console.error("건물 사진 이미지 URL을 Blob 객체로 변환 실패 : ", error)
                            return null;
                        }
                    }
                }));
                setPhotoImageFiles(newPhotoImageFiles);
            } else {
                alert(`${data}`);
            }
        })
    }, []);

    const onChange = (e, targetIndex) => {
        if (e.target.type === 'file') {
            const files = e.target.files;
            if (files.length > 0) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const image = e.target.result;
                    setFloorPlanImageFiles(floorPlanImageFiles.map((item, index) => {
                        if (index === targetIndex) {
                            return {
                                floorPlanImageSrc: image,
                                floorPlanImageFile: files[0]
                            };
                        }
                        return item;
                    }));
                };
                reader.readAsDataURL(files[0]);
            }
        } else {
            const name = e.target.name;
            const value = e.target.value;

            setDataSource(prevDataSource => {
                if (targetIndex >= prevDataSource.floors.length) {
                    return prevDataSource;
                }

                return {
                    ...prevDataSource,
                    floors: prevDataSource.floors.map((item, index) => {
                        if (index === targetIndex) {
                            return {
                                ...item,
                                [name]: value
                            }
                        }
                        return item;
                    })
                };
            })
        }
    }

    const showPreviewModal = (imageSrc) => {
        setPreviewImageSrc(imageSrc);
        setPreviewModalVisible(true);
    }

    const closePreviewModal = () => {
        setPreviewModalVisible(false);
    }

    const handleUploadImage = (e) => {
        e.preventDefault();

        if (dataSource === null) {
            alert(`등록된 건물 상세 현황이 없습니다. 등록을 먼저 해주세요.`)
        } else {
            if (dataSource.photos.length >= 10) {
                alert(`사진은 최대 10개까지 등록 가능합니다.`);
            } else {
                for (let i = 0; i < e.dataTransfer.files.length; i++) {
                    let file = e.dataTransfer.files[i];
                    if (file) {
                        if (getFileExtension(file.name) === "jpg" ||
                            getFileExtension(file.name) === "jpeg" ||
                            getFileExtension(file.name) === "png") {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                const image = e.target.result;
                                setPhotoImageFiles([...photoImageFiles, {
                                    photoImageSrc: image,
                                    photoImageFile: file
                                }]);
                            };
                            reader.readAsDataURL(file);
                        } else {
                            alert("이미지 파일(.jpg, .jpeg, .png)만 업로드 가능합니다.")
                        }
                    }
                }
            }
        }
    }

    const handleDelete = (e, targetIndex) => {
        const name = e.target.name;

        if (window.confirm("삭제하시겠습니까?")) {
            //층별 평면도
            if (name === "floorPlanImage") {
                setFloorPlanImageFiles(floorPlanImageFiles.map((item, index) => {
                    if (index === targetIndex) {
                        return null;
                    }
                    return item;
                }));

                //층별 평면도가 삭제되면 경계구역일람도도 삭제
                setBoundaryPreviewImageFiles(boundaryPreviewImageFiles.map((item, index) => {
                    if (index === targetIndex) {
                        return null;
                    }
                    return item;
                }));
            }
            //경계구역일람도
            else if (name === "boundaryAreaImage") {
                setBoundaryPreviewImageFiles(boundaryPreviewImageFiles.map((item, index) => {
                    if (index === targetIndex) {
                        return null;
                    }
                    return item;
                }));
            }

            //경계구역일람도 존재여부 재설정
            setDataSource(prevDataSource => {
                if (targetIndex >= prevDataSource.floors.length) {
                    return prevDataSource;
                }

                return {
                    ...prevDataSource,
                    floors: prevDataSource.floors.map((item, index) => {
                        if (index === targetIndex) {
                            return {
                                ...item,
                                isExistBoundaryAreaSetting: false,
                            }
                        }
                        return item;
                    })
                };
            })
        }
    }

    const handleDeleteImage = (targetIndex) => {
        setPhotoImageFiles(photoImageFiles.filter((item, index) => index !== targetIndex));
    }

    const getFileExtension = (fileName) => {
        const extension = fileName.slice(
            ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        );
        return extension;
    };

    const handleSave = () => {
        apiWrapper(async () => {
            const requestBody = new FormData();
            if (floorPlanImageFiles.length > 0) {
                floorPlanImageFiles.map((item, index) => {
                    requestBody.append(`floorPlanImage_${dataSource.floors[index].id}`, item === null ? null : item.floorPlanImageFile);
                });
            }
            if (photoImageFiles.length > 0) {
                photoImageFiles.map((item) => {
                    requestBody.append("photoImages", item === null ? null : item.photoImageFile);
                });
            }
            requestBody.append("payload",
                JSON.stringify({
                    id: dataSource.id,
                    serialNumber: dataSource.serialNumber,
                    dei: dataSource.dei,
                    floors: dataSource.floors.map((item) => {
                        return {
                            id: item.id,
                            floorLevel: item.floorLevel,
                            category: item.category,
                            floor: item.floor,
                            structure: item.structure,
                            use: item.use,
                            area: item.area,
                            isExistBoundaryArea: item.isExistBoundaryAreaSetting,
                        }
                    })
                }));

            const { status, data } = await fireonApi.updateBuildingDetail(id, requestBody);
            alert(`${data}`)

            if (status === true) {
                //성공 시 뒤로가기
                navigate(-1);
            }
        })
    }

    return (
        <>
            <div className="viewBoard fireOnBoard fireItemListBoard">
                <TopBoard header={props.header} />
                <MidColumnBoard />
                <TableBoard dataSource={dataSource} floorPlanImageFiles={floorPlanImageFiles} boundaryPreviewImageFiles={boundaryPreviewImageFiles} onChange={onChange} showPreviewModal={showPreviewModal} handleDelete={handleDelete} />
                <UploadBoard photoImageFiles={photoImageFiles} showPreviewModal={showPreviewModal} handleUploadImage={handleUploadImage} handleDeleteImage={handleDeleteImage} handleSave={handleSave} />
                <div className="wrap_btn_set mb">
                    <button className="btn_set btn_cancle">취소</button>
                    <button className="btn_set btn_save">저장</button>
                </div>
            </div>

            {isPreviewModalVisible && (
                <div class="previewModal" id="previewModal" style={{ display: 'block' }}>
                    <div class="modal-content" style={{ maxHeight: "100%", overflowY: 'auto' }}>
                        <button type="button" class="close_modal" onClick={closePreviewModal}>
                            <i class="x-icon close_icon"></i>
                        </button>
                        <div class="img-wrap">
                            <img id="previewImage" src={previewImageSrc} alt="" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

const TopBoard = ({ header }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { buildingName } = location.state;

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src={logo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">{buildingName}</p>
                </div>
                {header}
            </div>
        </>
    );
};

const MidColumnBoard = () => {
    let { id } = useParams();
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le">
                <div className="wrap_item_contr">
                    <div className="building_info">
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <p className="txt_info code_info">{serialNumber}</p>
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <p className="txt_info code_info">{dei}</p>
                        </div>
                    </div>
                </div>
                <div className="wrap_item_contr">
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/new/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        건축물 일반 현황
                    </Link>
                    <button
                        className="btn_contr btn_new active"
                    >
                        건축물 상세 현황
                    </button>
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/building-equipment-status/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        소방설비 등록 현황
                    </Link>
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/user-status/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        사용자 등록 현황
                    </Link>
                </div>
            </div>
        </div>
    );
};

const TableBoard = ({ dataSource, floorPlanImageFiles, boundaryPreviewImageFiles, onChange, showPreviewModal, handleDelete }) => {
    const { id } = useParams();
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    const handleWriteBoundaryMap = (e, targetIndex) => {
        if (dataSource.floors[targetIndex].floorPlanImage === null) {
            e.preventDefault();
            alert(`먼저 층별 평면도를 저장해주세요.`);
        }
    }

    return (
        <>
            <div className="table_board" style={{ marginTop: '0px' }}>
                <div className="wrap_right">
                    <div className="wrap_item_contr">
                        <div className="building_info mb">
                            <div className="item_info">
                                <p className="txt_info title_info">일련번호</p>
                                <p className="txt_info code_info">{serialNumber}</p>
                            </div>
                            <div className="item_info">
                                <p className="txt_info title_info">DEI 코드</p>
                                <p className="txt_info code_info">{dei}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wrap_table">
                    <div className="containerTable fireItemListTable">
                        <ul className="head_table">
                            <li><p>분류</p></li>
                            <li><p>층별</p></li>
                            <li><p>구조</p></li>
                            <li><p>용도</p></li>
                            <li><p>면적(㎡)</p></li>
                            <li><p>층별 평면도</p></li>
                            <li><p>경계구역 일람도</p></li>
                        </ul>

                        <div className="body_table">
                            <div className="inner_table_wrap">
                                {dataSource && dataSource.floors.length > 0 &&
                                    dataSource.floors.map((item, index) => (
                                        <div className="wrap_table_item" key={index}>
                                            <div className="inner_table_item table_item_01">
                                                <input className="tableInput" type="text" name="category" value={item.category} onChange={(e) => onChange(e, index)} />
                                            </div>
                                            <div className="inner_table_item table_item_02">
                                                <p className="cont_table_item">{item.floor}</p>
                                            </div>
                                            <div className="inner_table_item table_item_03">
                                                <input className="tableInput" type="text" name="structure" value={item.structure} onChange={(e) => onChange(e, index)} />
                                            </div>
                                            <div className="inner_table_item table_item_04">
                                                <input className="tableInput" type="text" name="use" value={item.use} onChange={(e) => onChange(e, index)} />
                                            </div>
                                            <div className="inner_table_item table_item_05">
                                                <input className="tableInput" type="text" pattern="^\d*\.?\d{0,2}$" name="area" value={item.area} onChange={(e) => onChange(e, index)} />
                                            </div>
                                            <div className="inner_table_item table_item_06">
                                                <div className="inner_dept">
                                                    {floorPlanImageFiles[index] !== null ? (
                                                        <>
                                                            <button className="btn_manage btn_preview" onClick={() => showPreviewModal(floorPlanImageFiles[index].floorPlanImageSrc)}>미리보기</button>
                                                            <button className="btn_manage btn_delete" name="floorPlanImage" onClick={(e) => handleDelete(e, index)}>삭제</button>
                                                        </>
                                                    ) : (
                                                        <label className="cont_find_item">
                                                            찾기
                                                            <input type="file" accept=".png, .jpg, .jpeg" name="floorPlanImage" onChange={(e) => onChange(e, index)} />
                                                        </label>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="inner_table_item table_item_07">
                                                <div className="inner_dept">
                                                    {item.isExistBoundaryAreaSetting && boundaryPreviewImageFiles[index] !== null ? (
                                                        <>
                                                            <button className="btn_manage btn_preview" onClick={() => showPreviewModal(boundaryPreviewImageFiles[index].boundaryPreviewImageSrc)} >미리보기</button>
                                                            <Link
                                                                className="btn_manage btn_edit"
                                                                to={`/fire-on/boundary-map/${id}?${new URLSearchParams({ floorLevel: item.floorLevel, floor: item.floor }).toString()}`}
                                                                state={{
                                                                    buildingName: buildingName,
                                                                    serialNumber: dataSource.serialNumber,
                                                                    dei: dataSource.dei,
                                                                }}
                                                            >
                                                                수정
                                                            </Link>
                                                            <button className="btn_manage btn_delete" name="boundaryAreaImage" onClick={(e) => handleDelete(e, index)}>삭제</button>
                                                        </>
                                                    ) : (
                                                        <Link
                                                            className="cont_write_item"
                                                            to={`/fire-on/boundary-map/${id}?${new URLSearchParams({ floorLevel: item.floorLevel, floor: item.floor }).toString()}`}
                                                            state={{
                                                                buildingName: buildingName,
                                                                serialNumber: dataSource.serialNumber,
                                                                dei: dataSource.dei,
                                                            }}
                                                            onClick={(e) => handleWriteBoundaryMap(e, index)}
                                                        >
                                                            작성
                                                        </Link>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const UploadBoard = ({ photoImageFiles, showPreviewModal, handleUploadImage, handleDeleteImage, handleSave }) => {
    const navigate = useNavigate();

    const handleCancel = () => {
        navigate(-1);
    }

    return (
        <div className="upload_board">
            <p className="title">건물 사진</p>
            <div className="zone_upload">
                <div
                    className="box_upload"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleUploadImage}
                >
                    <div className="guide_box">
                        <i className="x-icon"></i>
                        <p>이미지를 마우스로 끌어오세요.</p>
                    </div>
                </div>
                <div className="list_upload">
                    {photoImageFiles.length > 0 &&
                        photoImageFiles.map((item, index) => (
                            <div className="item_upload" key={index}>
                                <p className="item_title" onClick={() => { showPreviewModal(item.photoImageSrc); }}>{item.photoImageFile.name}</p>
                                <i className="x-icon del_icon" onClick={() => handleDeleteImage(index)}></i>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="wrap_btn_set pc">
                <button className="btn_set btn_cancle" onClick={handleCancel}>취소</button>
                <button className="btn_set btn_save" onClick={handleSave}>저장</button>
            </div>
        </div >
    );
};